import React from 'react';
import { FollowButton } from 'react-activity-feed';

export default function FollowBtn(props) {
  if (!props.user && props.toggleLoginModal) {
    return (
      <div className='login-to-follow-btn' onClick={props.toggleLoginModal}>
        Login to Follow
      </div>
    );
  }

  return <FollowButton onClick={props.isFollowing ? props.unfollow : props.follow} followed={props.isFollowing} />;
}
